module.exports = __webpack_public_path__ + "media/gateway/tasa-0-646ce43e.png";